import { useCallback, useState } from "react";
import { TRole } from "../../../../interfaces/users";
import { getSettingGPT } from "../../../../crud/users.crud";

export type IGPTSetting = {
  locale: string | null;
  type: "main_promt" | "promt" | "dialog_opening" | "avatar";
  update_at: string;
  user_role: TRole | null;
  value: string;
};
export const useGetSettingGPT = () => {
  const [loading, setLoading] = useState(false);
  const [setting, setSetting] = useState<IGPTSetting | null>(null);

  const fetchSetting = useCallback(
    async (type: "main_promt" | "promt" | "dialog_opening" | "avatar" | "model" | "model_2", locale?: string, user_role?: TRole) => {
      setLoading(true);
      getSettingGPT(type, locale, user_role)
        .then(res => {
          setSetting(res.data.data);
        })
        .catch(e => {
          setSetting(null);
          //   enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    []
  );

  return {
    fetchSetting,
    setting,
    loading,
  };
};
